
import { Apps as Portfolio } from './Portfolio/appDeclarations';
import { Apps as Energy } from './Energy/appDeclarations';

export const Apps = {
    ...Portfolio,
    ...Energy
}
